import { create } from 'zustand';

export const useMapSearchStore = create((set, get) => ({
	// Map state
	mapCenter: { lat: 52.16169, lng: 10.302 },
	mapZoom: 13,
	mapBounds: null,
	mapInstance: null,

	// Filter state
	selectedCategories: [],
	searchQuery: '',
	activeSearchMode: 'category',

	// Selection state
	selectedPlace: null,
	selectedPlaces: [],

	// UI state
	isModalOpen: false,
	sortBy: 'name',

	// Map actions
	setMapCenter: (mapCenter) => set({ mapCenter }),
	setMapZoom: (mapZoom) => set({ mapZoom }),
	setMapBounds: (mapBounds) => set({ mapBounds }),
	setMapInstance: (mapInstance) => set({ mapInstance }),

	// Filter actions
	handleCategoryChange: (categories) => {
		const update = {
			selectedCategories: categories,
			selectedPlace: null,
			selectedPlaces: [],
		};
		if (categories.length > 0) {
			update.activeSearchMode = 'category';
			update.searchQuery = '';
		}
		set(update);
	},

	handleSearchChange: (query) => {
		const update = {
			searchQuery: query,
			selectedPlace: null,
			selectedPlaces: [],
		};
		if (query) {
			update.activeSearchMode = 'name';
			update.selectedCategories = [];
		}
		set(update);
	},

	handleSearchClear: () =>
		set({
			searchQuery: '',
			activeSearchMode: 'category',
			selectedPlace: null,
			selectedPlaces: [],
		}),

	// Selection actions
	handleMarkerClick: (place) => set({ selectedPlace: place }),

	handleInfoWindowClose: () => set({ selectedPlace: null }),

	handlePlaceSelectionToggle: (place) => {
		const { selectedPlaces } = get();
		const placeId = place.placeId || place.place_id;
		const isSelected = selectedPlaces.some((p) => (p.placeId || p.place_id) === placeId);
		set({
			selectedPlaces: isSelected
				? selectedPlaces.filter((p) => (p.placeId || p.place_id) !== placeId)
				: [...selectedPlaces, place],
		});
	},

	handleSelectAll: (places) => {
		const { selectedPlaces } = get();
		set({
			selectedPlaces: selectedPlaces.length === places.length ? [] : [...places],
		});
	},

	// UI actions
	openModal: () => set({ isModalOpen: true }),
	closeModal: () => set({ isModalOpen: false }),
	setSortBy: (sortBy) => set({ sortBy }),
}));
